import { Box, Link as MuiLink, Stack, Typography } from '@mui/material';

import { Card } from '@/components/atoms/Card/Card';
import { Title } from '@/components/atoms/Title/Title';
import { SanityContent } from '@/components/organisms/SanityContent/SanityContent';
import EditorFields from '@/components/organisms/EditorFields/EditorFields';

import tos from './terms';

interface TOSProps {
  className?: string;
  consent?: any;
  setConsent?: (consent: any) => void;
  consentFields?: any;
  isHideConsent?: boolean;
}

/**
 * TOS renders the Terms of Service.
 */
export const TOS = ({
  consent,
  setConsent,
  consentFields,
  isHideConsent = false,
}: TOSProps) => (
  <Stack sx={{ height: '100%', maxHeight: '100%' }}>
    <Title>Terms of Service</Title>
    <Stack sx={{ flex: 1, overflow: 'hidden', gap: 3 }}>
      <Card elevation={0} isBordered={false} isPaddingSm>
        <Typography variant='body1' color='text.secondary'>
          You can read more about how we handle data safely in our{' '}
          <MuiLink
            href='https://karehero.com/privacy-policy'
            target='_blank'
            rel='noopener noreferrer'
            color='secondary'
            underline='hover'
          >
            privacy policy
          </MuiLink>
          . You will also need to agree to our Terms and Conditions.
        </Typography>
      </Card>
      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          bgcolor: 'background.paper',
          borderRadius: 2,
          p: 3,
        }}
      >
        <SanityContent content={tos} />
      </Box>
      {!isHideConsent && (
        <Card elevation={0} isBordered={false} color='yellow' isPaddingSm>
          <EditorFields
            fields={consentFields || []}
            value={consent}
            onChange={(f) => setConsent?.({ ...consent, ...f })}
          />
        </Card>
      )}
    </Stack>
  </Stack>
);

TOS.displayName = 'TOS';
export default TOS;
